import React, { useState } from "react";
import { Accordion, Separator, Text } from "glic-ui-components";
import { FormFields } from "./formFields";
import { Form } from "../../../../components/Form";
import { codeSnippetFunc } from "../../../../utils/commonFunctions";

const GoPaperlessComp = ({
  togglePaperlessOptionSelected,
}) => {
  const [isShowTermsAndConditionContents, showTermsAndConditionContents] =
    useState(false);

  const onChange = (e, value) => {
    const selectedValue = value === "true" ? true : false;
    togglePaperlessOptionSelected(selectedValue);
  };

  const onBlur = (e) => {
    console.log(e);
    codeSnippetFunc(
      "Form Step Completed",
      `Go Paperless Button -> value:${e.target.value.toUpperCase()}`,
      "track"
    );
  };

  return (
    <div className="terms-condition-container">
      <Separator />
      <Accordion
        onCollapse={() => showTermsAndConditionContents(false)}
        onExpand={() => showTermsAndConditionContents(true)}
      >
        <Accordion.Item
          uid="accordion-item-1"
          title="Go paperless!"
          headingLevel="h2"
        >
          {isShowTermsAndConditionContents ? (
            <div className="flex">
              <div className="flex-1 margin-top-1-rem">
                <Text className="agreement-text">
                  We’ll let you know by email when we put documents online. You
                  can change this setting in your profile, or contact us to get
                  paper copies. Some document types might still be sent by U.S.
                  Mail.
                </Text>
              </div>
              <div className="flex-1 margin-top-1-rem">
                <Form fields={FormFields} onChange={onChange} onBlur={onBlur} />
              </div>
            </div>
          ) : null}
        </Accordion.Item>
      </Accordion>
    </div>
  );
};
export const GoPaperless = GoPaperlessComp;